import { CommonModule } from '@angular/common';
import { MultilineTextComponent } from './multiline-text.component';
import { NgModule } from '@angular/core';
@NgModule({
    declarations: [MultilineTextComponent],
    imports: [CommonModule],
    exports: [MultilineTextComponent],
})
export class MultilineTextModule {}
